var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flechas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desarrollo-Juego",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-575, -502)",
    fill: "#C8FF49",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.6241,502.829787 L588.721226,509.575588 C588.857234,509.733003 588.857234,509.974884 588.719436,510.130379 L582.778004,516.617021 L579.857397,516.617021 L586.049371,509.850104 L579.708861,502.829787 L582.6241,502.829787 Z M578.066565,502.829787 L584.162494,509.575588 C584.300266,509.731083 584.300266,509.972964 584.162494,510.128459 L578.222229,516.615102 L575.302195,516.615102 L581.491164,509.850104 L575.151899,502.829787 L578.066565,502.829787 Z",
    id: "flechas"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechas);
export default __webpack_public_path__ + "static/media/flechas.3615aa3d43ceecc12715d880f73ba1b3.svg";
export { ForwardRef as ReactComponent };